<template>
    <div>
        <div>
            <el-form :model="form"  :inline="true" style="text-align:left;">
                <el-form-item label="综合查询:">
                    <el-input v-model="form.name" placeholder="请输入延保ID/产品名称" :clearable="true" ></el-input>
                </el-form-item>
               <el-form-item label="状态:">
                    <My-Select v-model="form.state" :objSelect="form.state" :options="options3" @changeSelct="changeQuerySelct"></My-Select>                 
                </el-form-item>
                <el-form-item label="品类:" >
                    <My-Select v-model="form.dicTypeCode" :objSelect="form.dicTypeCode" :options="categoryList" 
                    :optionBind="optionBindCategory" :placeholder="placeholderCategory" @changeSelct="changeSelctTypeCode(...arguments,'query')"></My-Select>  
                </el-form-item>                  
                <el-form-item >
                    <el-button type="primary" plain @click="query()">查询</el-button>  
                    <el-button type="primary" plain @click="ewProductEditor('add')">新建</el-button>                         
                </el-form-item>           
            </el-form>
        </div>
        <div>
            <My-table :configurationData="configurationData" :operation="operation" :getTableParam="getTableParam" ref="myTable">           
                <template #operation="scope">        
                    <el-button size="mini" type="primary" @click="ewProductEditor('update',scope.row)">修改</el-button>
                </template>
            </My-table> 
        </div>

        <el-dialog :title="title"  :visible.sync="ewProductEditorDialog" :close-on-click-modal=false width="1200px">
            <el-form :model="editorForm"  :inline="true" :rules="rules" ref="editorForm" label-width="110px" style="text-align:left;margin-left:25px">
                <el-row>                   
                    <el-col :span="8">
                        <el-form-item label="品类:" prop="dicTypeCode" class="ewProduct-select">
                            <My-Select v-model="editorForm.dicTypeCode" :objSelect="editorForm.dicTypeCode" :options="categoryList" 
                            :optionBind="optionBindCategory" :placeholder="placeholderCategory" @changeSelct="changeSelctTypeCode(...arguments,'form')"></My-Select>  
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="延保产品名称:" prop="prodName" label-width="110px" class="ewProduct-input">
                            <el-input v-model="editorForm.prodName" placeholder="请输入延保产品名称"></el-input>
                        </el-form-item> 
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="延保有效期:" class="input-name" prop="expiryDateYear">                          
                            <My-Selectnum v-model="editorForm.expiryDateYear" :objSelect="editorForm.expiryDateYear" :clearable="false" :options="optionsYear" :placeholder="placeholderYear" @changeSelct="changeSelctYear"></My-Selectnum>年                           
                        </el-form-item>
                        <el-form-item label="" class="input-name" prop="expiryDateYear">                           
                            <My-Selectnum v-model="editorForm.expiryDateMonth" :objSelect="editorForm.expiryDateMonth" :clearable="false" :options="optionsMonth" :placeholder="placeholderMonth" @changeSelct="changeSelctMonth"></My-Selectnum>月
                        </el-form-item> 
                    </el-col>
                </el-row>
                <el-row>                 
                    <el-col :span="8">
                        <el-form-item label="销售方式:" class="sellSelect-name" prop="sellType">
                            <My-Select v-model="editorForm.sellType" :objSelect="editorForm.sellType" :clearable=false :options="options1" @changeSelct="changeSelct"></My-Select>  
                        </el-form-item>
                        <el-form-item label="" class="sellSelect-name" prop="barCode" v-show="saleProxy"> 
                            <My-Select v-model="editorForm.barCode"  :objSelect="editorForm.barCode" :clearable="false" :options="barCodeList"  :optionBind="optionEnum" @changeSelct="changeSelctBarCode" :placeholder="placeholderBarCode"></My-Select> 
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="保障类型:" v-show="saleProxy" prop="guaranteeType" label-width="110px" class="guarantee-type-select">
                            <My-Select v-model="editorForm.guaranteeType"  :objSelect="editorForm.guaranteeType" :options="guaranteeTypeList"  :optionBind="optionEnum"
                            @changeSelct="changeSelctGuaranteeType" :placeholder="placeholderGuaranteeType"></My-Select> 
                        </el-form-item>
                        <el-form-item v-show="saleProxy">
                            <el-checkbox  v-model="editorForm.extendYears" true-label="Y" false-label="N">延长年限</el-checkbox>
                        </el-form-item>

                        <el-form-item label="产品详情URL:" v-show="saleSelf" prop="produceUrl" label-width="110px" class="ewProduct-input">
                            <el-input v-model="editorForm.produceUrl" placeholder="请输入产品详情URL"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="服务机构:" v-show="saleProxy" prop="agentBran" label-width="110px" class="ewProduct-input">
                            <el-input v-model="editorForm.agentBran" placeholder="请输入服务机构"></el-input>
                        </el-form-item>

                        <el-form-item label="服务协议URL:" v-show="saleSelf" prop="agreementUrl" label-width="110px" class="ewProduct-input">
                            <el-input v-model="editorForm.agreementUrl" placeholder="请输入服务协议URL"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row >                   
                    <el-col v-show="saleProxy" :span="16">
                        <el-form-item label="服务条款URL:" prop="termsServiceUrl" label-width="110px" class="termsServiceUrl-input">
                            <el-input v-model="editorForm.termsServiceUrl" placeholder="请输入服务条款URL"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col v-show="saleSelf" :span="16">
                         <el-form-item label="封面图片:" prop="img">
                            <el-upload
                                class="avatar-uploader"
                                action="/extwarapi/api/file/fileUpload"
                                :on-success="handleImgSuccess"
                                :on-change="handleImgChange"
                                :show-file-list="false"
                                :file-list="fileList"
                                >
                                <img v-if="this.editorForm.img" :src="this.editorForm.img" class="avatar">
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                    <el-col v-show="saleProxy" :span="8">     
                        <el-form-item label="允许购买延保:" prop="allowBuy" >
                            <el-input v-model="editorForm.allowBuy" placeholder="请输入天数"  class="allowBuy-class"><span slot="append">天</span></el-input>
                        </el-form-item>
                    </el-col>                                     
                </el-row>
                <el-row>
                    <el-col>
                        <el-form-item label="状态:" prop="state" >
                            <el-switch v-model="editorForm.state"></el-switch>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col>
                          <el-form-item label="服务项目:" prop="serviceCode">
                            <el-checkbox-group v-model="serviceCheckList" @change="changeService">                                
                                <el-checkbox v-for="(item,index) in serviceList" :label="item.serviceCode" :key="index">{{item.serviceName}}</el-checkbox>
                            </el-checkbox-group>
                        </el-form-item>   
                    </el-col>
                </el-row>                
            </el-form>
           <el-row style="text-align:right;margin-right:25px">
                <el-col >
                    <el-button type="success" plain size="mini" @click="addRow()">新增</el-button>
                </el-col>               
            </el-row>
            <el-row style="margin-left: 50px;margin-right: 25px">
                <el-tabs  v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="销售价格" name="salePrice">
                        <el-table :data="editorForm.extensionPricesModifyDtoList" border style="width: 100%;margin-top:5px;">
                            <el-table-column label="购机价格/房屋面积" >
                                <template slot-scope="scope">
                                    <p v-show=!scope.row.isShow> {{ scope.row.priceArea }}~{{ scope.row.priceAreaEnd }}</p>
                                    <el-input placeholder="please input min" type="number" v-model="scope.row.priceArea" v-show="scope.row.isShow" size="medium" class="priceArea-input" ></el-input>                                   
                                    <el-input placeholder="please input max" type="number" v-model="scope.row.priceAreaEnd" v-show="scope.row.isShow" size="medium" class="priceArea-input"></el-input>
                                </template>                       
                            </el-table-column>
                            <el-table-column label="销售价格"  >
                                <template slot-scope="scope">
                                    <p v-show=!scope.row.isShow> {{ scope.row.sellingPrice }}</p>
                                    <el-input placeholder="please input" v-model="scope.row.sellingPrice" v-show="scope.row.isShow" size="medium"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作">
                                <template slot-scope="scope">
                                    <el-button size="mini" @click="tableEdit(scope.$index, scope.row)"  v-show=!scope.row.isShow>编辑</el-button>
                                    <el-button size="mini" @click="tableEnter(scope.$index, scope.row)"  v-show=scope.row.isShow>确定</el-button>
                                    <el-button size="mini" type="danger" @click="tableDelte('update',scope.row)">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="fr clearfix">
                            <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="salePageNum"
                                :page-sizes="[5, 10, 20, 30, 40]"
                                :page-size="salePageSize"
                                layout="total, sizes, prev, pager, next,jumper"
                                :total="saleTotalNum">
                            </el-pagination>
                        </div> 
                    </el-tab-pane>
                    <el-tab-pane label="品牌保障年限" name="brandContract">
                        <el-table :data="editorForm.extensionExpiryModifyDtoList" border style="width: 100%;margin-top:5px;">
                            <el-table-column label="品牌" >
                                <template slot-scope="scope">
                                    <p v-show=!scope.row.isShow> {{ scope.row.dicBrandName }}</p>
                                    <My-Select v-show="scope.row.isShow" v-model="scope.row.dicBrandCode" :objSelect="scope.row.dicBrandCode" :options="brandList" 
                                    :optionBind="optionBindBrand" :placeholder="placeholderBrand"  @changeSelct="changeSelctBrand(...arguments,scope.row)"></My-Select>  
                                </template>
                            </el-table-column>
                            <el-table-column label="品牌的保障年限" >
                                <template slot-scope="scope">
                                    <p v-show=!scope.row.isShow> {{ formatDate(scope.row) }}</p>                            
                                    <My-Selectnum class="year-month-select" v-show="scope.row.isShow" v-model="scope.row.expiryDateYear" :objSelect="scope.row.expiryDateYear" :options="optionsYear" 
                                        :placeholder="placeholderYear" :clearable="false" @changeSelct="changeSelctYear(...arguments,scope.row)">年</My-Selectnum>                                
                                    <My-Selectnum class="year-month-select" v-show="scope.row.isShow" v-model="scope.row.expiryDateMonth" :objSelect="scope.row.expiryDateMonth" :options="optionsMonth" 
                                        :placeholder="placeholderMonth" :clearable="false" @changeSelct="changeSelctMonth(...arguments,scope.row)">月</My-Selectnum>                     
                                </template>
                            </el-table-column>
                            <el-table-column label="操作">
                                <template slot-scope="scope">
                                    <el-button size="mini" @click="tableEdit(scope.$index, scope.row)"  v-show=!scope.row.isShow>编辑</el-button>
                                    <el-button size="mini" @click="tableEnter(scope.$index, scope.row)"  v-show=scope.row.isShow>确定</el-button>
                                    <el-button size="mini" type="danger" @click="tableDelte('update',scope.row)">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="fr clearfix">
                            <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="brandPageNum"
                                :page-sizes="[5, 10, 20, 30, 40]"
                                :page-size="brandPageSize"
                                layout="total, sizes, prev, pager, next,jumper"
                                :total="brandTotalNum">
                            </el-pagination>
                        </div>            
                    </el-tab-pane>
        
                </el-tabs>
            </el-row>
          
            <div slot="footer" style="text-align:center">
                <el-button type="primary" @click="submitForm('editorForm')">确定</el-button>
                <el-button @click="resetForm('editorForm')">取消</el-button>
            </div>
        </el-dialog>   
    </div>
</template>

<script>
import common from '../../../public/static/common';
import  asyncApi   from '../../api/asyncApi';

export default { 
    name: 'ewProductManagement',
    data(){
        var expiryDateYear = (rule, value, callback) => {            
            if (!value && !this.editorForm.expiryDateMonth) {
                callback(new Error('请选择延保有效期年和月其中一项'));
            } else {
                callback();
            }
        };
        return{
            guaranteeTypeList:'',
            title:'',
            fileList:[],
            optionEnum:{
                label:"enumValue",
                value:"enumKey"
            },
            optionBindCategory:{
                label:"dicTypeName",
                value:"dicTypeCode"
            },
            optionBindBrand:{
                label:"dicBrandName",
                value:"dicBrandCode"
            },
            brandPageNum:1,
            brandPageSize:10,
            brandTotalNum:0,
            salePageNum: 1, // 当前页，默认1
            salePageSize: 10, // 每页行数，默认10         
            saleTotalNum: 0, // 总数
            activeName:'salePrice', 
            saleProxy:true,
            saleSelf:false,
            operationType:'',
            placeholderYear:'年数',
            placeholderMonth:'月数',
            placeholder:'请选择查询状态',
            placeholderCategory:'请选择品类名称',
            placeholderBrand:'请选择品牌名称',
            placeholderBarCode:'条码数',
            placeholderGuaranteeType:'请选择保障类型',
            form:{
                dicTypeCode:'',
                state:'',
                name:''
            },
             // 列表配置
            configurationData:[
                {
                    title: '延保产品ID',
                    propertys: 'prodCode',
                    width: ''
                },
                {
                    title: '品类',
                    propertys: 'dicTypeName',
                    width: ''
                },{
                    title: '延保产品名称',
                    propertys: 'prodName',
                    width: ''
                },
                {
                    title: '延保有效期',
                    propertys: 'expiryDate',
                    width: '',
                    format:this.formatDate
                },
                {
                    title: '状态',
                    propertys: 'state',
                    width: '',
                    format:common.formatState
                }
            ],
             // 是否有操作按钮 宽度
            operation: {
                show: true,
                width: ''
            },
            getTableParam:{
                url:'/extwarapi/api/extension/page',
                param:''
            },
            ewProductEditorDialog:false,
            editorForm:{
                id:'',
                dicTypeCode:'',
                prodName:'',
                expiryDateYear:null,
                expiryDateMonth:null,
                sellType:'1',
                barCode:'',
                guaranteeType:'',
                extendYears:'',
                termsServiceUrl:'',
                agentBran:'',
                serviceCode:[],
                produceUrl:'',
                agreementUrl:'',
                img:'',
                state:true,  
                allowBuy:'',              
                extensionPricesModifyDtoList:[{
                    id:'',
                    priceArea:'',
                    priceAreaEnd:'',
                    sellingPrice:'',
                    prodCode:'',
                    createUser:'',
                    modifyUser:'',
                }],
                extensionExpiryModifyDtoList:[{
                    id:'',
                    dicBrandCode:'',
                    dicBrandName:'',
                    expiryDateYear:null,
                    expiryDateMonth:null,
                    prodCode:'',
                    createUser:'',
                    modifyUser:'',
                }]
            },
            categoryList:[],
            serviceList:[],
            serviceCheckList:[],
            brandList:[],
            options1:[
                {"key":'1',"value":'代销'},
                {"key":'2',"value":'自购'}
            ],
            options3:[
                {"key":'',"value":'全部'},
                {"key":'N',"value":'停用中'},
                {"key":'Y',"value":'使用中'}
            ],
            optionsYear:[
                {"key":0,"value":0},
                {"key":1,"value":1},
                {"key":2,"value":2},
                {"key":3,"value":3},
                {"key":4,"value":4},
                {"key":5,"value":5},
                {"key":6,"value":6},
                {"key":7,"value":7},
                {"key":8,"value":8},
                {"key":9,"value":9},
                {"key":10,"value":10},
            ],
            optionsMonth:[
                {"key":0,"value":0},
                {"key":0.5,"value":0.5},
                {"key":1,"value":1},
                {"key":2,"value":2},
                {"key":3,"value":3},
                {"key":4,"value":4},
                {"key":5,"value":5},
                {"key":6,"value":6},
                {"key":7,"value":7},
                {"key":8,"value":8},
                {"key":9,"value":9},
                {"key":10,"value":10},
                {"key":11,"value":11},
                {"key":12,"value":12},
            ],
            tabName:'salePrice',
            salePriceList:[],
            brandContractList:[],
            rules: {
                dicTypeCode: [
                    { required: true, message: '请选择品类', trigger: 'blur' }
                ],
                prodName: [
                    { required: true, message: '请输入延保产品名称', trigger: 'blur' }
                ],
                expiryDateYear: [
                    { validator: expiryDateYear, required: true, trigger: 'blur' }
                ],
                sellType: [
                    { required: true, message: '请选择销售方式', trigger: 'blur' }
                ],
                barCode: [
                    { required: true, message: '请选择销售条码', trigger: 'blur' }
                ],
                guaranteeType: [
                    { required: true, message: '请选择保障类型', trigger: 'blur' }
                ],
                termsServiceUrl: [
                    { required: true, message: '请输入服务条款URL', trigger: 'blur' }
                ],
                agentBran: [
                    { required: true, message: '请输入服务机构', trigger: 'blur' }
                ],
                serviceCode: [
                    { required: true, message: '请选择服务项目', trigger: 'blur' }
                ],
                produceUrl: [
                    { required: true, message: '请输入产品详情URL', trigger: 'blur' }
                ],
                agreementUrl: [
                    { required: true, message: '请输入服务协议URL', trigger: 'blur' }
                ],
                img: [
                    { required: true, message: '请上传封面图片', trigger: 'blur' }
                ],
                state: [
                    { required: true, message: '请选择状态', trigger: 'blur' }
                ],
                allowBuy:[
                    {required: true, message: '请输入允许购买延保', trigger: 'blur'}
                ]
            },
            barCodeList:[],
        }
    },
    methods:{
        formatDate(row){
            let expiryDate='';           
            if(row.expiryDateYear){
                expiryDate=row.expiryDateYear+'年'
            }
            if(row.expiryDateMonth){
                expiryDate+= row.expiryDateMonth+'月' 
            }
            
            return expiryDate;
        },
        changeQuerySelct(value){
            this.form.state=value;
        },
        changeSelctGuaranteeType(value){
            this.editorForm.guaranteeType=value;
        },
        changeSelctYear(value,row){
            if(row){
                row.expiryDateYear=value;
            }else{
                this.editorForm.expiryDateYear=value;
            }            
        }, 
        changeSelctMonth(value,row){
            if(row){
                row.expiryDateMonth=value;
            }else{
                this.editorForm.expiryDateMonth=value;
            }           
        },
        ewProductEditor(operationType,row){
            this.fileList=[];
            this.operationType=operationType;
            this.serviceCheckList=[];
            if(operationType=='update'){
                this.title='延保产品修改';
                this.activeName='salePrice';
                this.getDetail(row);
            }else{
                //添加 
                this.title='延保产品新增';   
                this.editorForm.state=true;               
                this.editorForm=common.emptyModel(this.editorForm,["state","sellType"]);
                this.editorForm.expiryDateYear=null;
                this.editorForm.expiryDateMonth=null;
                this.editorForm.extensionPricesModifyDtoList=[];
                this.editorForm.extensionExpiryModifyDtoList=[];
                this.salePriceList=[];                
                this.brandContractList=[];
                this.saleTotalNum=0;
                this.brandTotalNum=0;
            }
            this.ewProductEditorDialog=true;
        },
        query(){
            this.getTableParam.param=this.form;
            this.$refs["myTable"].query(1);
        },
        //获取品类数据字典
        async getCategoryList(){
            let url ="/extwarapi/api/dicProdType/getTypeEnum";
            let data = await asyncApi.post(url,null);  
            if(data.code=='0000'){
                this.categoryList=data.result;
            }
        },
        //获取服务项目数据字典
        async getServiceList(){
            let url ="/extwarapi/api/dicServiceItem/getServiceEnum";
            let data = await asyncApi.post(url,null);  
            if(data.code=='0000'){
                this.serviceList=data.result;
            }
        },
        //获取品牌数据字典
        async getBrandList(){
            let url ="/extwarapi/api/dicProdBrand/getBrandEnum";
            let data = await asyncApi.post(url,null);  
            if(data.code=='0000'){
                this.brandList=data.result;  
            }
        }, 
       //获取保障类型数据字典
        async getGuaranteeTypeList(){
            let url ="/extwarapi/api/tools/getEnumsByCode";
            let data = await asyncApi.post(url,{code:'guaranteeType'});  
            if(data.code=='0000'){
                this.guaranteeTypeList=data.result;
            }
        }, 
        //获取条码数数据字典
        async getBarCodeList(){
            let url ="/extwarapi/api/tools/getEnumsByCode";
            let data = await asyncApi.post(url,{code:'barCode'});  
            if(data.code=='0000'){
                this.barCodeList=data.result;
            }
        }, 
        //销售方式 
        changeSelct(value){
            if(value==1){
                this.saleProxy=true;
                this.saleSelf=false;
            }else{
                this.saleProxy=false;
                this.saleSelf=true;
            }
            this.editorForm.sellType=value;
        },
        //品类
        changeSelctTypeCode(value,val){
            if(val=='form'){
                this.editorForm.dicTypeCode=value;
            }else if(val=='query'){
                this.form.dicTypeCode=value;
            }
           
        },
        //服务项目
        changeService(value){
            this.editorForm.serviceCode=value;
        },
        //条码
        changeSelctBarCode(value){
            this.editorForm.barCode=value;
        },
        //tab页签切换
        handleClick(tab, event){            
            this.tabName=tab.name;
        },
        getDetail(row){
            let url="/extwarapi/api/extension/getDetailById";
            this.axios.post(url, {id:row.id}).then((resp) => {  
                if(resp.data.code=='0000'){                   
             
                    this.editorForm.id=resp.data.result.id;
                    this.editorForm.dicTypeCode=resp.data.result.dicTypeCode;
                    this.editorForm.prodName=resp.data.result.prodName;
                    this.editorForm.prodCode=resp.data.result.prodCode;
                    this.editorForm.sellType=resp.data.result.sellType;
                    this.editorForm.guaranteeType=resp.data.result.guaranteeType;
                    this.editorForm.extendYears=resp.data.result.extendYears;
                    this.editorForm.agentBran=resp.data.result.agentBran;
                    this.editorForm.produceUrl=resp.data.result.produceUrl;
                    this.editorForm.agreementUrl=resp.data.result.agreementUrl;
                    this.editorForm.img=resp.data.result.img;
                    this.editorForm.barCode=resp.data.result.barCode;
                    this.editorForm.serviceCode=resp.data.result.serviceCode;
                    this.editorForm.allowBuy=resp.data.result.allowBuy;

                    if(resp.data.result.sellType=='1'){
                        this.editorForm.termsServiceUrl=resp.data.result.agreementUrl;
                    }

                    this.editorForm.expiryDateYear=resp.data.result.expiryDateYear;
                    this.editorForm.expiryDateMonth=resp.data.result.expiryDateMonth;
                
                    if(this.editorForm.state=='Y'){
                        this.editorForm.state=true;
                    }else if(this.editorForm.state=='N'){
                        this.editorForm.state=false;
                    }
                    let serviceCode=resp.data.result.serviceCode;
                    for(let i=0;i<serviceCode.length;i++){
                        this.serviceCheckList.push(serviceCode[i]);
                    }

                    if(resp.data.result.extensionPricesDtoList){
                        this.saleTotalNum=resp.data.result.extensionPricesDtoList.length;
                        this.salePriceList=resp.data.result.extensionPricesDtoList;
                        this.editorForm.extensionPricesModifyDtoList=this.getPageList(this.salePageNum,this.salePageSize,this.saleTotalNum,this.salePriceList);
                    }
                    if(resp.data.result.extensionExpiryDtoList){
                        this.brandTotalNum=resp.data.result.extensionExpiryDtoList.length;
                        this.brandContractList=resp.data.result.extensionExpiryDtoList;
                        this.editorForm.extensionExpiryModifyDtoList=this.getPageList(this.brandPageNum,this.brandPageSize,this.brandTotalNum,this.brandContractList);
                    }
                }     
            }).catch((resp) => {
                //console.log('error', resp); 
            })
        },
        handleSizeChange(val) {  
            if(this.tabName=='salePrice'){                        
                this.salePageSize = val;
                this.editorForm.extensionPricesModifyDtoList=this.getPageList(this.salePageNum,this.salePageSize,this.saleTotalNum,this.salePriceList);
               
            }else{
                this.brandPageSize=val;
                this.editorForm.extensionExpiryModifyDtoList= this.getPageList(this.brandPageNum,this.brandPageSize,this.brandTotalNum,this.brandContractList);
            }    
        },
        handleCurrentChange(val) {
            if(this.tabName=='salePrice'){
                this.salePageNum = val;  
                this.editorForm.extensionPricesModifyDtoList=this.getPageList(this.salePageNum,this.salePageSize,this.saleTotalNum,this.salePriceList);
            }else{
                this.brandPageNum=val;
                this.editorForm.extensionExpiryModifyDtoList= this.getPageList(this.brandPageNum,this.brandPageSize,this.brandTotalNum,this.brandContractList);
            }
        },
       addRow(){   
           var row='';        
           if(this.tabName=='salePrice'){
                row={
                    id:'',
                    priceArea:'',
                    priceAreaEnd:'',
                    sellingPrice:'',
                    prodCode:'',
                    createUser:'',
                    modifyUser:'',
                    isShow:true
                }
            this.salePriceList.push(row);
            this.saleTotalNum++;            
            this.editorForm.extensionPricesModifyDtoList=this.getPageList(this.salePageNum,this.salePageSize,this.saleTotalNum,this.salePriceList);
           }else{
                row={
                    id:'',
                    dicBrandCode:'',
                    dicBrandName:'',
                    expiryDateYear:null,
                    expiryDateMonth:null,
                    expiryDate:'',
                    prodCode:'',
                    createUser:'',
                    modifyUser:'',
                    isShow:true
                }
            this.brandContractList.push(row);
            this.brandTotalNum++;            
            this.editorForm.extensionExpiryModifyDtoList= this.getPageList(this.brandPageNum,this.brandPageSize,this.brandTotalNum,this.brandContractList);
           }           
        },
        getPageList(pageNum,pageSize,totalNum,list){
            let startRow = (pageNum - 1) * pageSize+1-1;//开始显示的行  
            let endRow = pageNum * pageSize;//结束显示的行
            endRow = (endRow > totalNum)? totalNum : endRow;
            return list.slice(startRow,endRow);
        },
        tableEdit(index,row){   
          row.isShow = true;
          if(this.tabName=='salePrice'){
              this.$set(this.editorForm.extensionPricesModifyDtoList,index, row);
          }else{
              //
              this.$set(this.editorForm.extensionExpiryModifyDtoList,index, row);
          }
          
        },
        tableDelte(index,row){
            if(this.tabName=='salePrice'){
                if(this.operationType=='add'){
                    this.salePriceList.splice(index, 1);
                    this.editorForm.extensionPricesModifyDtoList.splice(index, 1);
                    this.saleTotalNum--;
                }else{
                    //修改的时候删除表格数据调用接口
                    if(row.id){
                        row.state='D';
                        this.updatePrices(index, row);
                    }else{
                        this.salePriceList.splice(index, 1);
                        this.editorForm.extensionPricesModifyDtoList.splice(index, 1);
                        this.saleTotalNum--;
                    }
                }
            }else{
                if(this.operationType=='add'){
                    this.brandContractList.splice(index, 1);
                    this.editorForm.extensionExpiryModifyDtoList.splice(index, 1);
                    this.brandTotalNum--;
                }else{
                    //修改的时候删除表格数据调用接口
                    if(row.id){
                        row.state='D';
                        this.updateContract(index, row);
                    }else{
                        this.salePriceList.splice(index, 1);
                        this.editorForm.extensionPricesModifyDtoList.splice(index, 1);
                        this.saleTotalNum--;
                    }
                }
            }
        },
        tableEnter(index,row){
            row.isShow = false;
            if(this.tabName=='salePrice'){
                if(row.priceArea==='' || row.priceArea<0){
                    this.$alert('购机价格/房屋面积最小值为必填项', '提示信息', {
                        confirmButtonText: '确定',
                        callback: action => {
                            row.isShow = true;
                        }
                    });
                    return;
                }                
                if(row.priceAreaEnd==='' || row.priceAreaEnd<0){
                    this.$alert('购机价格/房屋面积最大值为必填项', '提示信息', {
                        confirmButtonText: '确定',
                        callback: action => {
                            row.isShow = true;
                        }
                    });
                    return;
                }                

                if(this.operationType=='add'){
                    this.$set(this.editorForm.extensionPricesModifyDtoList,index, row);
                }
                //修改的时候编辑表格调用接口
                if(this.operationType=='update'){
                    this.updatePrices(index,row);
                }  
            }else{
                if(row.dicBrandCode===''){
                    this.$alert('请选择品牌名称', '提示信息', {
                        confirmButtonText: '确定',
                        callback: action => {
                            row.isShow = true;
                        }
                    });
                    return;
                }
                this.formatDate(row);
                if(this.operationType=='add'){
                    this.$set(this.editorForm.extensionExpiryModifyDtoList,index, row);
                }
                //修改的时候编辑表格调用接口
                if(this.operationType=='update'){
                    this.updateContract(index,row);
                }
            }  
        },
        updatePrices(index,row){
            let usercode=common.getCurrUser().userCode;
            let url="";
            if(row.id){
                url="/extwarapi/api/extension/updatePrices";
            }else{                
                url="/extwarapi/api/extension/addPrices";
            }            
            let param={
                prodCode:this.editorForm.prodCode,
                id:row.id,
                priceArea:row.priceArea,
                priceAreaEnd:row.priceAreaEnd,
                sellingPrice:row.sellingPrice,               
                createUser:usercode,
                modifyUser:usercode,
                state:row.state,
            }
            this.axios.post(url, param).then((resp) => { 
                    if(resp.data.code=='0000'){                        
                        this.$set(this.editorForm.extensionPricesModifyDtoList,index, row); 
                        if(row.state=='D'){
                            this.salePriceList.splice(index, 1);
                            this.editorForm.extensionPricesModifyDtoList.splice(index, 1);
                            this.saleTotalNum--;
                        }  
                                           
                    }                
                }).catch((resp) => {
                        //console.log('error', resp); 
                });
        },
        updateContract(index,row){
            let usercode=common.getCurrUser().userCode;
            let url="";
            if(row.id){
                url="/extwarapi/api/extension/updateExpiry";
            }else{                
                url="/extwarapi/api/extension/addExpiry";
            }            
            let param={
                prodCode:this.editorForm.prodCode,
                id:row.id,
                expiryDateYear:row.expiryDateYear,
                expiryDateMonth:row.expiryDateMonth,
                dicBrandCode:row.dicBrandCode,               
                createUser:usercode,
                modifyUser:usercode,
                state:row.state,
            }
            this.axios.post(url, param).then((resp) => { 
                    if(resp.data.code=='0000'){
                        this.$set(this.editorForm.extensionExpiryModifyDtoList,index, row);
                        if(row.state=='D'){
                            this.brandContractList.splice(index, 1);
                            this.editorForm.extensionExpiryModifyDtoList.splice(index, 1);
                            this.brandTotalNum--;
                        }                      
                    }                
                }).catch((resp) => {
                        //console.log('error', resp); 
                });
        },
        changeSelctBrand(value,row){
            let brandName=common.getVbyK(this.brandList,value,"dicBrandCode","dicBrandName");            
            row.dicBrandCode=value;
            row.dicBrandName=brandName;
        },
       
        //封面图片上传
        handleImgSuccess(res, file){
            this.editorForm.img = res.result
        },
        handleImgChange(file, fileList){
           //console.log(fileList.length);
        
                 if (fileList.length > 0) {
                     this.fileList = [fileList[fileList.length - 1]]  // 这一步，是 展示最后一次选择的csv文件
                 }
          
        },

        submitForm(formName){
            let usercode=common.getCurrUser().userCode;
            let url="";
            let param=Object.assign({},this.editorForm);
                param.createUser=usercode;
                param.modifyUser=usercode;
            if(param.state){
                param.state='Y';
            }else{
                param.state='N';
            }

            if(this.operationType=='add'){
                url="/extwarapi/api/extension/add";
            }else{
                param.extensionPricesModifyDtoList=[];
                param.extensionExpiryModifyDtoList=[];
                url="/extwarapi/api/extension/update";
            }
            let validFields=["prodCode","dicTypeCode","prodName","expiryDateYear","sellType","serviceCode","state"];

            if(param.sellType=="1"){                
                validFields.push("barCode");
                validFields.push("guaranteeType");
                validFields.push("termsServiceUrl");
                validFields.push("agentBran");
                validFields.push("allowBuy");
                param.produceUrl='';         
                param.agreementUrl=param.termsServiceUrl;
                param.img='';              
            }else if(param.sellType=="2"){
                validFields.push("produceUrl");
                validFields.push("agreementUrl");
                validFields.push("img");
                param.barCode='';
                param.guaranteeType='';
                param.termsServiceUrl='';
                param.agentBran='';
                param.data='';
            }
            let me = this;
            let allValid = true;
            this.$refs[formName].validateField(validFields,(valid) => {
                if(valid.length>0){
                    allValid = false;
                }                
            });

            if (allValid) {
                me.axios.post(url, param).then((resp) => {
                    if(resp.data.code=='0000'){
                        this.$alert("操作成功!", '提示信息', {
                            confirmButtonText: '确定',
                            callback: action => { 
                                me.ewProductEditorDialog=false;
                                me.$refs["myTable"].query(1); 
                            }
                        });
                    }else{
                        this.$alert(resp.data.msg, '提示信息', {
                                confirmButtonText: '确定',
                                callback: action => {                            
                            }
                        });
                        return;
                    }   
                                 
                }).catch((resp) => {
                    //console.log('error', resp); 
                })
            } else {
                //console.log('error submit!!',allValid);
                return false;
            }
        },
        resetForm(formName) {
            this.ewProductEditorDialog=false;
            this.$refs[formName].resetFields(); 
        },

    },
    mounted(){
        this.getCategoryList();
        this.getServiceList();
        this.getBrandList();
        this.getGuaranteeTypeList();
        this.getBarCodeList();
    },
    watch:{
        salePageNum(newVal, oldVal){
            if(newVal!==oldVal){                
                this.editorForm.extensionPricesModifyDtoList=this.getPageList(this.salePageNum,this.salePageSize,this.saleTotalNum,this.salePriceList);
            }
        },
        salePageSize(newVal, oldVal){
            if(newVal!==oldVal){
               this.editorForm.extensionPricesModifyDtoList=this.getPageList(this.salePageNum,this.salePageSize,this.saleTotalNum,this.salePriceList);
            }
        },
        brandPageNum(newVal, oldVal){
            if(newVal!==oldVal){                
                this.editorForm.extensionExpiryModifyDtoList=this.getPageList(this.brandPageNum,this.brandPageSize,this.brandTotalNum,this.brandContractList);
            }
        },
        brandPageSize(newVal, oldVal){
            if(newVal!==oldVal){
                this.editorForm.extensionExpiryModifyDtoList=this.getPageList(this.brandPageNum,this.brandPageSize,this.brandTotalNum,this.brandContractList);
            }
        }
    }
 
}
</script>
<style lang="scss" >
 .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 235px;
    height: 100px;
    line-height: 100px;
    text-align: center;
    border:1px dashed rgb(223, 215, 215);
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
.input-name .el-input{
    width: 100px;  
}
.ewProduct-input .el-input{
    width: 240px;  
}
.ewProduct-select .el-input--suffix{
    width: 240px;  
}
.sellSelect-name .el-input--suffix{
    width: 115px
}
.priceArea-input {
    width: 150px;
}
.guarantee-type-select .el-input__inner{
    width: 150px;
}
.termsServiceUrl-input .el-input{
    width: 615px;  
}
.year-month-select .el-input--suffix{
    width: 150px;
}
.el-input-group__append {
    background-color: white; 
    color: #606266; 
    border: 0px; 
    padding: 0px;
  
}
.allowBuy-class .el-input__inner{
    width: 224px;
}
</style>